<template>
  <article class="example-page">
    <h1>Date Picker</h1>
    <form @submit.prevent>
      <label for="dateMin">Lowest Level View</label>
      <select id="dateMin" v-model="dateMin">
        <option value="day">day</option>
        <option value="month">month</option>
        <option value="year">year</option>
      </select>
      <label for="dateMax">Highest Level View</label>
      <select id="dateMax" v-model="dateMax">
        <option value="day" :disabled="dateMin === 'month' || dateMin === 'year'">day</option>
        <option value="month" :disabled="dateMin === 'year'">month</option>
        <option value="year">year</option>
      </select>
      <label for="format">Date Format</label>
      <input id="format" v-model="dateFormat" type="text">
      <legend>
        <input id="range" v-model="dateRange" type="checkbox"><label for="range">Selected Date Range</label>
      </legend>
      <fieldset>
        <label>Enabled Dates Start - {{ enabledStart }}</label>
        <date-picker v-model="enabledStart" :minimum-view="'day'" :maximum-view="'year'" :format="'MMMM DD YYYY'" :disabled="!dateRange" />
        <label>Enabled Dates End - {{ enabledEnd }}</label>
        <date-picker v-model="enabledEnd" :minimum-view="'day'" :maximum-view="'year'" :format="'MMMM DD YYYY'" :disabled="!dateRange" />
      </fieldset>
    </form>
    <hr>
    <h2>Result</h2>
    <section>
      Selected Date - {{ selectedDate }}
      <date-picker
        v-model="selectedDate"
        :position="'center'"
        :minimum-view="dateMin"
        :maximum-view="dateMax"
        :enabled-dates="enabledDates"
        :format="dateFormat"
      />
    </section>
  </article>
</template>

<script>
import { datePicker } from '@/components/layout';

export default {
  components: { datePicker },
  data() {
    return {
      dateMin: 'day',
      dateMax: 'year',
      dateRange: false,
      dateFormat: 'MMM YYYY',
      enabledStart: new Date(),
      enabledEnd: new Date(),
      enabledDates: { },
      selectedDate: new Date(),
    };
  },
  watch: {
    enabledStart() {
      this.enabledDates = {
        to: this.enabledStart,
        from: this.enabledEnd,
      };
    },
    enabledEnd() {
      this.enabledDates = {
        to: this.enabledStart,
        from: this.enabledEnd,
      };
    },
    dateRange() {
      if (this.dateRange === false) {
        this.enabledDates = {};
      } else {
        this.enabledDates = {
          to: this.enabledStart,
          from: this.enabledEnd,
        };
      }
    },
  },
};
</script>
